import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from './PdfStyles';

const PdfCheckbox = ({ label, checked, isRadio = false }) => (
  <View style={styles.checkboxContainer}>
    <View style={styles.checkboxMark}>
      <Text style={styles.checkboxText}>{checked ?  'X' : ' '}</Text>
    </View>
    <Text style={styles.checkboxLabel}>{label}</Text>
  </View>
);

export default PdfCheckbox;